import { SectionTitle, Section, Feature } from 'react-scale/components';

const Benefits = ({ benefitsTitle }) => (
  <Section id="benefits" theme="light" bg="bg-codGray">
    <SectionTitle
      overtitle={benefitsTitle.overtitle}
      title={benefitsTitle.title}
      subtitle={benefitsTitle.subtitle}
    />
    <Feature
      cols={2}
      spacing="sm"
      features={[
        {
          img: {
            width: 592,
            height: 355,
            url: '/static/images/pages/careers/benefits/puppies.png',
            alt: 'A person playing with dogs'
          },
          overtitle: ' ',
          title: 'Health & Wellbeing',
          text: 'Our holistic approach to supporting Scaliens includes comprehensive health coverage, dental and vision insurance, mental healthcare services, and more. PTO policies and accommodating schedules ensure you’ll get time off when you need it to relax and recharge. Note that our offerings may vary by region as we strive to respond to the unique needs of Scaliens around the globe.'
        },
        {
          img: {
            width: 592,
            height: 355,
            url: '/static/images/pages/careers/benefits/zoom-call.png',
            alt: 'A zoom call '
          },
          overtitle: ' ',
          title: 'Personal & Career Growth',
          text: 'Continuously learn and grow through annual learning & development stipend, attending leadership breakfasts, manager training, speaker series, and joining an ERG.'
        },
        {
          img: {
            width: 592,
            height: 355,
            url: '/static/images/pages/careers/benefits/scale-office.png',
            alt: 'Scale office'
          },
          overtitle: ' ',
          title: 'Building Scale Community',
          text: 'We welcome guests to our offices, and you can expect to see Scalien families and friends around. Join local happy hours, and accept invites to game nights, book clubs, and many other employee-led community events.'
        },
        {
          img: {
            width: 592,
            height: 355,
            url: '/static/images/pages/careers/benefits/family.png',
            alt: 'A family at a living room'
          },
          overtitle: ' ',
          title: 'Parental Support',
          text: 'Balancing work and family is essential, and Scale understands the importance of having adequate leave policies in place to promote a healthy home and work life.'
        }
      ]}
    />
  </Section>
);

export default Benefits;
